import {LOAD_ACCOUNT_DATA, DELETE_A_ACCOUNT, SAVE_A_ACCOUNT, UPDATE_A_ACCOUNT} from './actions';

const initialState = {
  accountsArray:[],
    deleteAccountResp:{},
    errorCMsg:{},
    saveAccountResp:{},
    updateAccountResp:{}
};




export default function reducer(state = initialState, action) {
  switch (action.type) {
      case LOAD_ACCOUNT_DATA:
          return Object.assign({}, state, {
              accountsArray: action.accountsData
          });
          case DELETE_A_ACCOUNT:
          return Object.assign({}, state, {
              deleteAccountResp: action.deleteAccountResponse,
              errorCMsg: action.errorMsg
          });
      case SAVE_A_ACCOUNT:
          return Object.assign({}, state, {
              saveAccountResp: action.saveAccountResponse,
              errorCMsg: action.errorMsg
          });
      case UPDATE_A_ACCOUNT:
          return Object.assign({}, state, {
              updateAccountResp: action.saveAccountResponse,
              errorCMsg: action.errorMsg
          });
    /*case LOAD_FARMS_SUCCESS:
      return {
        ...state,
        //all: [...action.payload.categories],  Farshid Uncommnet this out after you know teh payload from the server.
      };*/
    default:
      return state;
  }
}
